import {RegionSuggestInterface} from "@/views/Admin/Statistic/Member/RegionSuggest/RegionSuggest.interface";

export const RegionSuggestSchema: RegionSuggestInterface = {
    initialValue: null,
}
